import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: 'admin' | 'dealer';
}
export const ProtectedRoute = ({
  children,
  requiredRole
}: ProtectedRouteProps) => {
  const {
    isAuthenticated,
    userRole
  } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-1213" />;
  }
  if (userRole !== requiredRole) {
    // Redirect to the appropriate dashboard or unauthorized page
    if (userRole === 'admin') {
      return <Navigate to="/admin" replace data-id="element-1214" />;
    } else if (userRole === 'dealer') {
      return <Navigate to="/dealer" replace data-id="element-1215" />;
    } else {
      return <Navigate to="/unauthorized" replace data-id="element-1216" />;
    }
  }
  return <>{children}</>;
};